var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "line-chart" }, [
    _vm.tableName
      ? _c("h5", [
          _vm._v("\n            " + _vm._s(_vm.tableName) + "\n        ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.subHeader
      ? _c("span", { staticClass: "sub-header" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.subHeader) + "\n\t\t")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.timestamp
      ? _c("span", { staticClass: "timestamp" }, [
          _c("p", { staticClass: "label" }, [_vm._v("Timestamp: ")]),
          _vm._v("\n            " + _vm._s(_vm.timestamp) + "\n        ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("section", { staticClass: "chart-container" }, [
      _c("canvas", { attrs: { id: _vm.uniqueId } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f689ec6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f689ec6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppChartQuadrant.vue
// module id = null
// module chunks = 